function isReactSnap(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
}

export function loadGTM(id: string): void {
  if (isReactSnap() || !id || document.querySelector('script[data-gtm]')) return;
  const s = document.createElement('script');
  s.setAttribute('data-gtm', id);
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(s);

  // dataLayer init
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
}

export function loadGA4(id: string): void {
  if (isReactSnap() || !id || document.querySelector('script[data-ga4]')) return;
  const s = document.createElement('script');
  s.setAttribute('data-ga4', id);
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);

  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', id);
}

export function loadMetaPixel(id: string): void {
  if (isReactSnap() || !id || document.querySelector('script[data-meta-pixel]')) return;

  /* eslint-disable */
  const f = window as any;
  const n = (f.fbq = function () {
    (n as any).callMethod
      ? (n as any).callMethod.apply(n, arguments)
      : (n as any).queue.push(arguments);
  }) as any;
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  /* eslint-enable */

  const s = document.createElement('script');
  s.setAttribute('data-meta-pixel', id);
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);

  f.fbq('init', id);
  f.fbq('track', 'PageView');
}
